import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.css';
import * as serviceWorker from './serviceWorker';
import { LanguageProvider } from './context/LanguageContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <LanguageProvider>
    <App />
  </LanguageProvider>
);

serviceWorker.unregister();
